import { render, staticRenderFns } from "./_BookingGroupedTable.vue?vue&type=template&id=18bbbc7b"
import script from "./_BookingGroupedTable.vue?vue&type=script&lang=js"
export * from "./_BookingGroupedTable.vue?vue&type=script&lang=js"
import style0 from "./_BookingGroupedTable.vue?vue&type=style&index=0&id=18bbbc7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports